import {svgIconWrapper} from '../svg-icon-wrapper';

import BellRegular from './bell-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <BellRegular {...validProps} />;
}

SvgComponent.iconName = 'bellRegular';

export const BellRegularIcon = svgIconWrapper(SvgComponent);
